import { render, staticRenderFns } from "./Employee-cards.vue?vue&type=template&id=1f036be7&"
import script from "./Employee-cards.vue?vue&type=script&lang=js&"
export * from "./Employee-cards.vue?vue&type=script&lang=js&"
import style0 from "./Employee-cards.vue?vue&type=style&index=0&id=1f036be7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports